<template>
  <div class="app-single-topup-amount-input">
    <slot name="txtBefore">
    </slot>
    <b-form class="amount-input-form"
             :id="'form' + _uid">
      <b-form-group>
        <b-form-row>
          <b-col class="input-col">
            <b-form-input
              name="amount"
              data-amount
              @input="$v.amount.$touch"
              v-model="amount"
              :state="isValid('amount')"
              type="number"
              aria-describedby="amount-live-feedback"
            ></b-form-input>
            <b-form-invalid-feedback id="amount-live-feedback">
              <slot v-if="!$v.amount.isValid" name="amountLiveFeedback">
                Bitte Betrag zwischen {{amounts.min}} und {{amounts.max}} wählen.
              </slot>
            </b-form-invalid-feedback>
          </b-col>
          <b-col class="stepper-col">
            <Stepper
              :show-prev="false"
              @next="next()"
              :disabled-next="$v.$invalid"
            >
              <template #btnPrev><slot name="btnPrev"></slot></template>
              <template #btnNext><slot name="btnNext"></slot></template>
            </Stepper>
          </b-col>
        </b-form-row>
      </b-form-group>
    </b-form>
    <slot name="txtAfter"></slot>
  </div>
</template>

<script>
import processSteps from '../../../../../mixins/processSteps'
import Stepper from '../../../../generic/Stepper.vue'
import { mapMutations } from 'vuex'
import price from '@/mixins/price'
import { validationMixin } from 'vuelidate'
import { maxValue, minValue, numeric, required } from 'vuelidate/lib/validators'
import isValid from '../../../../../mixins/isValid'

export const stepName = 'amountSelect'

export default {
  name: 'SingleTopUpAmountInput',
  components: { Stepper },
  mixins: [
    processSteps(stepName, stepName, stepName),
    price,
    validationMixin,
    isValid
  ],
  methods: {
    ...mapMutations('topUp/single', [
      'changeStep'
    ]),
    next () {
      this.changeStep({ step: this.nextStep, amount: (this.amount * 100) })
    }
  },
  data () {
    return {
      amount: null
    }
  },
  computed: {
  },
  props: {
    amounts: {
      type: Object,
      required: true
    }
  },
  validations () {
    return {
      amount: {
        required,
        numeric,
        minValue: minValue(this.amounts.min),
        maxValue: maxValue(this.amounts.max)
      }
    }
  }
}
</script>
